import { enableTooltip, enablePopover } from 'bs';
document.addEventListener('turbo:load', enableTooltip);
document.addEventListener('turbo:load', enablePopover);
